import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import { getApiBaseUrl } from './utils/apiUrl';
import './index.css';
import App from './App';

// Configure axios baseURL: empty in prod (same-origin /api via nginx), localhost:5001 in dev
const apiBaseUrl = getApiBaseUrl();
axios.defaults.baseURL = apiBaseUrl;
if (process.env.NODE_ENV === 'development') {
  console.log('[API] baseURL:', apiBaseUrl || '(empty - using proxy to backend)');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
// Temporarily disable StrictMode to prevent double mounting during development
root.render(<App />);

